import { Post } from '../models';
import { PostRepository } from '../repositories';
import { logger } from '@/src/core/utils';
import { ModerateContentUseCase } from './ModerateContentUseCase';

export class CreatePostUseCase {
  constructor(
    private postRepository: PostRepository,
    private moderateContent: ModerateContentUseCase,
  ) {}

  async execute(userId: string, content: string, imageUrl?: string, tournamentId?: string): Promise<Post> {
    logger.debug('CreatePost', 'Creating post', { userId, contentLength: content.length, hasImage: !!imageUrl, tournamentId });

    // Validate content
    if (!content || content.trim().length === 0) {
      throw new Error('Post content is required');
    }

    if (content.length > 500) {
      throw new Error('Post content must be 500 characters or less');
    }

    // Moderate content before writing
    await this.moderateContent.execute(content, 'post_content', userId);

    const post = await this.postRepository.create(userId, content.trim(), imageUrl, tournamentId);

    logger.info('CreatePost', 'Post created successfully', { postId: post.id });

    return post;
  }
}
